import {createSlice} from '@reduxjs/toolkit';
import {primaryRole, hasRole, hasAnyRole} from '../../utils/permissions';

// Multi-role: roles is the source of truth. Legacy `role` is intentionally not
// stored here - components must use the helpers from utils/permissions.
const initialState = {
  id: '',
  accessToken: '',
  first_name: '',
  last_name: '',
  email: '',
  username: '',
  phone: '',
  company_id: null,
  avatar_s3_key: null,
  roles: [],
  companies: [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAccessToken(state, action) {
      state.accessToken = action.payload;
    },
    setUser(state, action) {
      const {role, ...rest} = action.payload || {};
      // Backward compat: if some legacy caller still sends role, fold it into roles[].
      const merged = {...state, ...rest};
      if (!Array.isArray(merged.roles)) merged.roles = [];
      if (!Array.isArray(merged.companies)) merged.companies = [];
      if (role && !merged.roles.includes(role)) merged.roles.push(role);
      // A platform super-admin operates with owner-level capability once inside a
      // company. Mirror the API (isAuth injects `owner`) so every owner-gated UI
      // works; the app still routes them through the company picker first because
      // the `super_admin` role is what the picker gate keys off.
      if (merged.roles.includes('super_admin') && !merged.roles.includes('owner')) {
        merged.roles.push('owner');
      }
      return merged;
    },
    removeUser() {
      return initialState;
    },
  },
});

// Selectors
export const getUser = (state) => state.user;
export const getUserToken = (state) => state.user.accessToken;
export const getUserRoles = (state) => state.user.roles || [];
export const getPrimaryRole = (state) => primaryRole(state.user);
export const userHasRole = (role) => (state) => hasRole(state.user, role);
export const userHasAnyRole = (roles) => (state) => hasAnyRole(state.user, roles);

// Actions
export const {setAccessToken, setUser, removeUser} = userSlice.actions;

export default userSlice.reducer;
